module.exports = {
	"description": "The Link component creates a hyperlink to external pages, files, anchors on the same page or another URL.\nLinks trigger an action, select an option, or provide a gateway to more information.\nLinks are used to reduce clutter on a page when there are potentially many actions available.\n\nLinks with clear messaging and an appropriate variant applied communicate intention effectively.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Content of the Link"
		},
		"href": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "A URL or URL fragment to which the Link points"
		},
		"element": {
			"flowType": {
				"name": "$FlowFixMe"
			},
			"required": false,
			"description": "Element to be used as the root node - e.g. \"a\" or {&nbsp;ReactRouterLink&nbsp;}",
			"defaultValue": {
				"value": "'a'",
				"computed": false
			}
		},
		"variant": {
			"flowType": {
				"name": "union",
				"raw": "'regular' | 'danger' | 'success' | 'warning'",
				"elements": [
					{
						"name": "literal",
						"value": "'regular'"
					},
					{
						"name": "literal",
						"value": "'danger'"
					},
					{
						"name": "literal",
						"value": "'success'"
					},
					{
						"name": "literal",
						"value": "'warning'"
					}
				]
			},
			"required": false,
			"description": "Available variants",
			"defaultValue": {
				"value": "'regular'",
				"computed": false
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Link/Link.js
// module id = 1659
// module chunks = 0